/* eslint-disable import/prefer-default-export */
import { bpPut } from '@/utils/services';

/**
 * API all to PUT the appropriate coverages data.
 *
 * @param {string} coverageId
 * @param {object} payload
 * @returns {Promise}
 */
export function putCoverageProp(coverageId, payload = {}) {
  return bpPut(`coverages/${coverageId}`, payload);
}
